<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "AsideWrapper",
    props: {collapsed: Boolean}
}
</script>

<style scoped>

</style>
